<template>
    <div>
        <div id="content-to-print" ref="pdfContent">
            <!-- 这里是你要导出的内容 -->
            <div class="titleinfo">
                <span style="font-size: 35px;margin-top: 10px">{{this.dzzsForm.zsmc}}</span><br/>
                <span>职业技能认定证书</span>
            </div>
            <div class="contentinfo">
                <span>证书编号：&nbsp;&nbsp;{{this.dzzsForm.zsbh}}</span><br/><br/>
                <span>证书类型：&nbsp;&nbsp;{{this.dzzsForm.zslx}}</span><br/><br/>
                <span>行业类型：&nbsp;&nbsp;{{this.dzzsForm.hylx}}</span><br/><br/>
                <span>证书等级：&nbsp;&nbsp;{{this.dzzsForm.zsdj}}</span><br/><br/>
                <span>总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分：&nbsp;&nbsp;{{this.dzzsForm.zf}}</span><br/><br/>
                <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：&nbsp;&nbsp;{{this.dzzsForm.xm}}</span>
            </div>
            <div class="footerinfo">
                <span></span><br/>
                <span>授予日期：{{this.dzzsForm.syrq}}</span>
            </div>

        </div>
<!--        <div style="text-align: center;margin-top: 20px">-->
<!--            <button @click="convertHTMLToPDF">下载证书</button>-->
<!--        </div>-->

    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
    props:{
        transKsbmId: {type: String,default () {return null;}},
    },
    data() {
        return {
            dzzsForm: {
                id: null,
                zsmc: null,
                zsbh: null,
                zslx: null,
                hylx: null,
                zsdj: null,
                zf: null,
                xm: null,
                syrq: null,
            },
        };
    },
    created() {
        this.dzzsForm.id  = this.transKsbmId;
    },
    mounted() {
        this.queryDzzsInfo();
    },
    methods: {
        queryDzzsInfo() {
            this.$api.gradesAssess.assessmentList.queryDzzsInfo({
                data: this.dzzsForm.id,
            }).then((res) => {
                this.dzzsForm.zsmc = res.data.data.dzzsInfo.zsmc;
                this.dzzsForm.zsbh = res.data.data.dzzsInfo.zsbh;
                this.dzzsForm.zslx = res.data.data.dzzsInfo.zslx;
                this.dzzsForm.hylx = res.data.data.dzzsInfo.hylx;
                this.dzzsForm.zsdj = res.data.data.dzzsInfo.zsdj;
                this.dzzsForm.zf = res.data.data.dzzsInfo.zf;
                this.dzzsForm.xm = res.data.data.dzzsInfo.xm;
                var rq = res.data.data.dzzsInfo.syrq.split('-');
                this.dzzsForm.syrq = rq[0] + '年' + rq[1] + '月' + rq[2] + '日';

            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        exportPDF() {
            const content = this.$refs.pdfContent;
            html2canvas(content).then(canvas => {
                const pdf = new jsPDF();
                const imgData = canvas.toDataURL('image/png');
                const imgProps= pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save('download.pdf');
            });
        },
        convertHTMLToPDF() {
            const element = document.getElementById('content-to-print'); // 获取包含HTML内容的元素
            // const pdf = html2pdf().fromHTML(element, {
            //     margin: 1, // 设置边距（以毫米为单位）
            //     filename: 'certificate.pdf', // 设置生成的PDF文件名
            //     image: { type: 'jpeg', quality: 0.98 }, // 设置图片质量
            //     html2canvas: { dpi: 192, letterRendering: true }, // 设置canvas渲染选项
            //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }, // 设置生成的PDF的单位、格式和方向
            // });
            // pdf.save(); // 保存生成的PDF文件
        },
    },
}
</script>

<style scoped>
#content-to-print {
    width: 100%;
    height: 500px;
    background-image: url("image.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding-top: 40px;
}
.titleinfo{
    font-size: 20px;
    text-align: center;
    margin: 20px 50px;
}
.contentinfo{
    font-size: 20px;
    margin-left: 50px;
}
.footerinfo{
    font-size: 20px;
    text-align: right;
    margin-left: 50px;
    margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// stuServicesDzzs.vue?22a84202